import { reactive } from 'vue'

export const i18nCalendar = reactive({
  clear: 'Clear',
  confirm: 'Confirm',
})

export const i18nConfirm = reactive({
  cancel: 'Cancel',
  confirm: 'Confirm',
})

export const i18nDisabledHelp = reactive({
  thisButtonIsDisabledBecause: 'This button is disabled because:',
  invalidInput: 'Invalid input',
})

export const i18nForm = reactive({
  match: 'This field does not match $match',
  mismatch: 'This field matches $mismatch',
  gt: 'This field must be greater than $gt',
  gte: 'This field must be equal to $gte or greater',
  in: 'This field must be one of: $in',
  lt: 'This field must be less than $lt',
  lte: 'This field must be equal to $lte or less',
  max: 'This field must be at most $max',
  maxString: 'This field can not be longer than $max characters',
  min: 'This field must be least $min',
  minString: 'This field must be at least $min characters long',
  remove: 'Remove',
  required: 'This field is required',
  type: 'This field must be type $type',
})

export const i18nFormBuilder = reactive({
  addAnswerOption: 'Add answer option',
  addFollowUpQuestion: 'Add follow up question',
  addAnotherRepeatableItem: 'Add another $repeatable',
  addQuestion: 'Add question',
  addSection: 'Add section',
  addSubtitle: 'Add subtitle',
  allowMultipleAnswers: 'Allow multiple answers',
  allowThirdOption: 'Allow third option',
  answer: 'Answer',
  answerOptions: 'Answer options',
  confirmRemove: 'Are you sure you want to remove "$title"?',
  countQuestionsRequireAttention: '$count questions require attention',
  datepicker: 'Date picker',
  description: 'Description',
  dropdown: 'Drop down',
  enterTheDescription: 'Enter the description',
  enterTheQuestion: 'Enter the question',
  enterTheSubtitle: 'Enter the subtitle',
  enterTitle: 'Enter title',
  fileUpload: 'File upload',
  includeDescription: 'Include description',
  internal: 'Internal',
  nameOfRepeatableItem: 'Name of repeatable item',
  no: 'No',
  number: 'Number',
  optional: 'Optional',
  paragraph: 'Paragraph',
  question: 'Question',
  rename: 'Rename',
  repeater: 'Repeater',
  sections: 'Sections',
  shortAnswer: 'Short answer',
  startByAddingYourFirstQuestion: 'Start by adding your first question',
  subtitle: 'Subtitle',
  trueFalse: 'True / False',
  url: 'URL',
  userCanEnterANumber: 'User can enter a number',
  userCanEnterAUrl: 'User can enter a URL',
  userCanPickADate: 'User can pick a date',
  userCanTypeLongTextInATextarea: 'User can type long text in a text area',
  userCanTypeTextInATextarea: 'User can type text in a text area',
  userCanUploadOrDragFileHere: 'User can upload or drag file here',
  yes: 'Yes',
})

export const i18nInput = reactive({
  required: 'required',
  optional: 'optional',
})

export const i18nSelect = reactive({
  noResultsFoundForYourInput: 'No results found for your input',
  noResultsFound: 'No results found',
  addAll: 'Select all',
  removeAll: 'Remove all',
  suggested: 'Suggested $label',
  showLess: 'Show less',
  showMore: 'Show more',
})

export const i18nTable = reactive({
  noData: 'No data',
})

export const i18nUploadDragger = reactive({
  clickToUpload: 'click to upload',
  dragAndDrop: 'Drag and drop',
  optional: 'optional',
  or: 'or',
})

const locales = {
  Confirm: i18nConfirm,
  DisabledHelp: i18nDisabledHelp,
  VCalendar: i18nCalendar,
  VForm: i18nForm,
  VInput: i18nInput,
  VSelect: i18nSelect,
  VUploadDragger: i18nUploadDragger,
  VFormBuilder: i18nFormBuilder,
  VTable: i18nTable,
}

export type Messages = {
  [key in keyof typeof locales]: (typeof locales)[key]
}
export function setMessages(messages: Messages) {
  let locale: keyof typeof locales
  for (locale in messages) {
    Object.assign(locales[locale], messages[locale])
  }
}
